function ArrowLeft({ size = '14', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00006 12.75L1.07077 6.82071C1.03172 6.78166 1.03172 6.71834 1.07077 6.67929L7.00006 0.75"
        stroke="#20293C"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default ArrowLeft;
